import { useCommunication } from "@/lib/CommunicationWrapper";
import { GoogleSvg, MicrosoftSvg } from "@/lib/svg"
import { ExternalLink } from "lucide-react"
import { useEffect, useState } from "react";


export const SyncButton = () => {
    const { loadSharedComponent, useRerenderListener, checkGateBoolean } = useCommunication();


    const { options, trigger } = useRerenderListener(["google_cal_sync_token", "microsoft_cal_sync_token"]);
    const [restricted, setRestricted] = useState(false);

    useEffect(() => {
        checkGateBoolean("calendarSync").then(({ restricted }) => {
            setRestricted(restricted);
        });
    }, [trigger]);

    const hasGoogleSync = options.google_cal_sync_token;
    const hasMicrosoftSync = options.microsoft_cal_sync_token;
    const hasSync = hasGoogleSync || hasMicrosoftSync;

    const shouldShowGoogleSync = !hasSync || hasGoogleSync;
    const shouldShowMicrosoftSync = !hasSync || hasMicrosoftSync;
    const shouldShowSyncRestriction = hasSync && restricted;

    return (
        <button
            onClick={() => loadSharedComponent("CalendarSyncGate", { showCloseButton: true })}
            className="flex items-center gap-1.5 text-sm font-medium text-theme-1 hover:bg-theme-1 hover:text-theme-0 transition-colors px-[10px] rounded-lg py-1 border border-theme"
        >

            <div className="flex items-center">
                {shouldShowMicrosoftSync && (
                    <div className="bg-theme-0 rounded-full p-0.5">
                        <MicrosoftSvg className="size-[13px]" />
                    </div>
                )}
                {shouldShowGoogleSync && (
                    <div className={`${shouldShowMicrosoftSync ? "-ml-1.5" : ""} bg-theme-0 rounded-full p-0.5`}>
                        <GoogleSvg className="size-[13px]" />
                    </div>
                )}
            </div>
            {!hasSync && <p className="text-sm text-theme-0">Sync</p>}
            {shouldShowSyncRestriction && <p className="text-sm text-theme-0">3d</p>}
        </button>
    )
}
